module.exports = __webpack_public_path__ + "img/1477756686.2c9a7ed5.jpg";